import { Injectable } from '@angular/core';
import { GeminiRealtimeSegment } from './gemini-realtime.segment';
import { GeminiLiveSegment } from './gemini-live.segment';
import { GrokRealtimeSegment } from './grok-realtime.segment';
import { OpenAiRealtimeSegment } from './openai-realtime.segment';
import { RealtimeSegment, RealtimeSegmentId } from './realtime-segment.types';

@Injectable({ providedIn: 'root' })
export class RealtimeSegmentSelectorService {
    private readonly storageKey = 'agent1.realtime.segment';

    // Runtime-only override (not persisted). The kiosk sets this to 'grok' while
    // its agent is active so Grok stays scoped to the kiosk without changing the
    // global default (which the admin drawer and everything else still use).
    private _override: RealtimeSegmentId | null = null;

    constructor(
        private readonly openai: OpenAiRealtimeSegment,
        private readonly gemini: GeminiRealtimeSegment,
        private readonly gemini2: GeminiLiveSegment,
        private readonly grok: GrokRealtimeSegment
    ) {}

    getActiveSegment(): RealtimeSegment {
        switch (this.getConfiguredSegmentId()) {
            case 'openai':
                return this.openai;
            case 'grok':
                return this.grok;
            case 'gemini2':
                return this.gemini2;
            default:
                return this.gemini;
        }
    }

    getConfiguredSegmentId(): RealtimeSegmentId {
        if (this._override) {
            return this._override;
        }
        const raw = String(localStorage.getItem(this.storageKey) ?? '').toLowerCase();
        if (raw === 'openai') return 'openai';
        if (raw === 'grok') return 'grok';
        if (raw === 'gemini2') return 'gemini2';
        // Default to gemini — OpenAI is dormant until re-enabled
        return 'gemini';
    }

    setConfiguredSegmentId(id: RealtimeSegmentId): void {
        localStorage.setItem(this.storageKey, id);
    }

    /** Set (or clear with null) a non-persistent segment override. */
    setRuntimeOverride(id: RealtimeSegmentId | null): void {
        this._override = id;
    }
}
